export const pipe =
  (...fns: CallableFunction[]) =>
  (x: any) =>
    fns.reduce((v, f) => f(v), x);
